import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

// Check URL hash for direct navigation (e.g., #risk-analysis)
const hash = window.location.hash.replace('#', '');
if (hash && ['clause-library', 'clause-suggestion', 'obligation', 'collaboration', 'risk-analysis', 'contacts', 'contract-summary'].includes(hash)) {
  localStorage.setItem('ezylex-view', hash);
  window.location.hash = ''; // Clear hash
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
